"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnackbarContainer = exports.useSnackbarContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const snackbar_1 = require("./snackbar");
const defaultValue = {
    show: () => ({}),
    hide: () => ({}),
};
const SnackbarContext = React.createContext(defaultValue);
const useSnackbarContext = () => React.useContext(SnackbarContext);
exports.useSnackbarContext = useSnackbarContext;
function SnackbarContainer(props) {
    const [isOpen, setIsOpen] = React.useState(false);
    const onClose = () => setIsOpen(false);
    // explicitly defined to show which severity is default
    const defaultSeverity = 'success';
    const defaultSnack = {
        open: false,
        autoHideDuration: 4000,
        // onClose on snackbar is used for off click close
        onClose,
        alertProps: {
            // explicitly defined to show how to use default mapped icon
            icon: undefined,
            severity: defaultSeverity,
            onClose,
        },
    };
    const [snack, setSnack] = React.useState(defaultSnack);
    const formatAlertProps = (type, snackbarShowProps, additionalProps) => {
        var _a;
        const alertProps = (_a = additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.alertProps) !== null && _a !== void 0 ? _a : {};
        const severity = type !== null && type !== void 0 ? type : defaultSeverity;
        if (!snackbarShowProps) {
            return Object.assign(Object.assign({}, defaultSnack.alertProps), { severity });
        }
        let ctaAction = undefined;
        if (snackbarShowProps.ctaContent && snackbarShowProps.ctaOnClick) {
            ctaAction = ((0, jsx_runtime_1.jsx)(snackbar_1.SnackbarAlertCtaButton, Object.assign({ onClick: snackbarShowProps.ctaOnClick, severity: severity }, { children: snackbarShowProps.ctaContent }), void 0));
        }
        const onCloseWrapped = (event) => {
            onClose();
            if (snackbarShowProps.otherOnCloseAction) {
                snackbarShowProps.otherOnCloseAction(event);
            }
        };
        return Object.assign(Object.assign({}, alertProps), { 
            // pass onClose to alert if closeIcon should show
            onClose: snackbarShowProps.shouldHideCloseIcon ? undefined : onCloseWrapped, icon: snackbarShowProps.icon, action: ctaAction, severity });
    };
    const snackbar = React.useMemo(() => ({
        show: (message, type, snackbarShowProps, additionalProps) => {
            var _a;
            setSnack(Object.assign(Object.assign(Object.assign({}, defaultSnack), additionalProps), { alertProps: formatAlertProps(type, snackbarShowProps, additionalProps), autoHideDuration: (_a = snackbarShowProps === null || snackbarShowProps === void 0 ? void 0 : snackbarShowProps.duration) !== null && _a !== void 0 ? _a : defaultSnack.autoHideDuration, message }));
            setIsOpen(true);
        },
        hide: () => onClose(),
    }), [snack]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(snackbar_1.SnackbarAlert, Object.assign({}, snack, { open: isOpen }), void 0), (0, jsx_runtime_1.jsx)(SnackbarContext.Provider, Object.assign({ value: snackbar }, { children: props.children }), void 0)] }, void 0));
}
exports.SnackbarContainer = SnackbarContainer;
//# sourceMappingURL=snackbar-container.js.map